import {db} from "../../../Firebase";
import * as firebase from "firebase";
import {getDateWithHourMnSeconds} from "../../calcul/getDate";
import {SHOW_SNACKBAR} from "../../type";


/**
 * This function will add a comment for a recipe, if the current user already have comment,
 * the old one will be overwritten
 * @param values    {object}: contain user's pseudo, recipe name and text
 */
export const addComment = (values) => async dispatch => {
    try {
        let id = "";
        let ancientComment = null;
        await db.collection("recipes").where("name", "==", values.recipeName).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                id = doc.id

                //if this recipe have already some comments, we search if the current user already have comment
                if (doc.data().comments) {
                    ancientComment = doc.data().comments.find(element => element.user === values.userPseudo);
                }
            });
        });

        let recipeRef = db.collection("recipes").doc(id);
        if (ancientComment) { //if the current user already add a comment for this recipe, we remove the old one
            await recipeRef.update({comments: firebase.firestore.FieldValue.arrayRemove(ancientComment)});
        }

        //format needed to add date in firestore => let dateValue = new Date("December 10, 2015, 16:13:05")
        let dateFinal = new Date(getDateWithHourMnSeconds(Date.now()));
        await recipeRef.update({
            comments: firebase.firestore.FieldValue.arrayUnion({
                text: values.text,
                user: values.userPseudo,
                date: dateFinal
            })
        });
        dispatch({type: SHOW_SNACKBAR, payload: {txt: 'commentaire ajouté', variant: "success"}});

    } catch (e) {
        dispatch({type: SHOW_SNACKBAR, payload: {txt: "une erreur est survenue lors de l'ajout du commentaire", variant: "error"}});
    }
};


